import { all, call, takeEvery, fork } from "redux-saga/effects";
import newRequestFunction from "../Utils/newSGF"

import {
  SAVE_SYSTEM_SETTINGS,
  GET_SYSTEM_SETTINGS,
} from "../ActionTypes";

import {
  saveSystemSettingsSuccess,
  saveSystemSettingsFailure,

  getSystemSettingsSuccess,
  getSystemSettingsFailure
} from "../Actions";

import {
  saveSystemSettingsApi,
  getSystemSettingsApi,
} from "../Api"


// Requests
const saveSystemSettingsRequest = function* ({ payload }) {
  yield call(newRequestFunction, saveSystemSettingsSuccess, saveSystemSettingsFailure, saveSystemSettingsApi, payload)
}

const getSystemSettingsRequest = function* ({ payload }) {
  yield call(newRequestFunction, getSystemSettingsSuccess, getSystemSettingsFailure, getSystemSettingsApi, payload)
}


// Watchers
const saveSystemSettingsWatcher = function* () {
  yield takeEvery(SAVE_SYSTEM_SETTINGS, saveSystemSettingsRequest)
}

const getSystemSettingsWatcher = function* () {
  yield takeEvery(GET_SYSTEM_SETTINGS, getSystemSettingsRequest)
}

export default function* rootSaga() {
  yield all([
    fork(saveSystemSettingsWatcher),
    fork(getSystemSettingsWatcher),
  ])
}